import { createElement } from 'react'
import {
    outlook as outlookFn,
    outlookMobile as outlookMobileFn,
} from 'calendar-link'

import { CalOutlookIcon } from '@pleio/icons/cal-outlook'

import { type CalendarEvent } from '../CalendarEvent'
import { type WebCalendarService } from '../CalendarLink'
import descriptionAsHtml, { addBreak } from '../descriptionAsHtml'
import normalizeLocation from '../normalizeLocation'

export default function outlook(
    label: string,
    isMobile: boolean,
): (event: CalendarEvent) => WebCalendarService {
    return function outlookLink(event: CalendarEvent): WebCalendarService {
        return {
            label,
            url: (isMobile ? outlookMobileFn : outlookFn)({
                start: event.start,
                end: event.end,
                title: event.title,
                description: descriptionAsHtml(event, addBreak()),
                location: normalizeLocation(event),
                url: event.eventPageUrl,
            }),
            newWindow: true,
            iconBefore: createElement(CalOutlookIcon),
        }
    }
}
